import React from 'react';

import ConnectedForm from 'components/ui/ConnectedForm';

import FormKeys from 'modules/form/types/FormKeys';

import PageBaseProps from 'types/PageBase';

import VehicleCheckFormRender from './VehicleCheckFormRender';
import PopupErrorForm from '../Errors/PopupErrorForm';
import type { VehicleCheckForm as VehicleCheckFormType } from '../../types/VehicleCheckForm';
import { setIn } from 'final-form';
import { useSelector } from 'react-redux';
import { isVehicleCheckEnabled as isVehicleCheckEnabledSelector } from 'modules/auth/selectors';
import { isCourtesyVehicleCheckEnabled as isCourtesyVehicleCheckEnabledSelector } from 'modules/selfServices/selectors';
import { IntlShape, useIntl } from 'react-intl';

interface ValidateFormProps {
  intl:IntlShape,
  isVehicleCheckEnabled:boolean,
  isCourtesyVehicleCheckEnabled:boolean
}

const validateForm = ({ intl, isVehicleCheckEnabled, isCourtesyVehicleCheckEnabled }:ValidateFormProps) =>
  (values:Partial<VehicleCheckFormType>) => {
    let res = {};
    if (isVehicleCheckEnabled && !values.vehicleCheck) {
      res = setIn(res, 'vehicleCheck', intl.formatMessage({
        id: 'validation.required',
        defaultMessage: 'Please answer to continue.',
      }));
    }
    if (isCourtesyVehicleCheckEnabled && !values.courtesyVehicleCheck) {
      res = setIn(res, 'vehicleCheck', intl.formatMessage({
        id: 'validation.required',
        defaultMessage: 'Please answer to continue.',
      }));
    }
    return res;
  };

const VehicleCheckForm: React.FC<PageBaseProps> = ({ onNext, onPrev, shouldDisplayBackButton }) => {
  const intl = useIntl();
  const isVehicleCheckEnabled = useSelector(isVehicleCheckEnabledSelector);
  const isCourtesyVehicleCheckEnabled = useSelector(isCourtesyVehicleCheckEnabledSelector);

  return (
    <ConnectedForm
      onPrev={onPrev}
      onSubmit={onNext}
      validate={validateForm({ intl, isVehicleCheckEnabled, isCourtesyVehicleCheckEnabled })}
      component={VehicleCheckFormRender}
      shouldDisplayBackButton={shouldDisplayBackButton}
      formKey={FormKeys.VEHICLE_CHECK}
      errorComponent={<PopupErrorForm errorMessage={{
        id: 'questions.mandatoryModal.title',
        defaultMessage: 'You must first answer {count, plural, one {the question} other {all questions}} marked with "{mandatory}".',
      }} />}
      subscription={{ hasValidationErrors: true, errors: true }}
    />
  );
};

export default VehicleCheckForm;
